module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-hd-8e8fea4f.svg";